import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-digital-videos-add',
  templateUrl: './college-videos-add.component.html',
  styleUrls: ['./college-videos-add.component.scss']
})
export class CollegeVideosComponent implements OnInit {

  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;
  images = null;
  apiUrl = null;
  imageObj: File;

  constructor(private ActivatedRoute: ActivatedRoute, private formBuilder: FormBuilder,  private http: HttpClient, private router: Router) { }

  ngOnInit() {
    let role = localStorage.getItem('userRole');
    let user = localStorage.getItem('userId');

      this.Form = this.formBuilder.group({
          file: ['', Validators.required],
          _id: [],
      });

      this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
          this.http.get<any>(`${environment.apiUrl}/videosByCollegeId/${id}`, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
              data => {
                (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
              this.images = data.data;
              this.apiUrl = `${environment.apiUrl}`;
              this.Form.patchValue({
                  _id: id
              });
          },
          (err: HttpErrorResponse) => {
              if (err.error instanceof Error) {
              console.log("Client-side error occured.");
              } else {
              console.log("Server-side error occured.");
              }
          });
      });
  }

  public settings = {
      actions: {
        position: 'right',
        add: false,
        edit: false,
        delete: true
      },
      delete :{
        confirmDelete: true
      },
      columns: {
        video: {
          title:'Videos',
          type:'html',
          valuePrepareFunction:(cell,row)=>{
            return `<a href="${this.apiUrl + '/' + row.video}" width="150" height="100" target="_blank">${row.video}</a>`;
          },
          filter:false
        },
      },
    };

  onImagePicked(event: Event): void {
      const FILE = (event.target as HTMLInputElement).files[0];
      this.imageObj = FILE;
  }

  get f() { return this.Form.controls; }

  onImageUpload() {
      this.submitted = true;
  
      if (this.Form.invalid) {
        return;
      }

      const imageForm = new FormData();
      imageForm.append('image', this.imageObj);
      imageForm.append('collegeid', this.Form.value._id);
      imageForm.append('userid', (localStorage.getItem('userRole') != 'super-admin') ? localStorage.getItem('userId') : '');

      this.http.post<any>(`${environment.apiUrl}/videos/`, imageForm, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
          data => {
            (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
              if(data.status == '500'){
                  this.message = data.message;
                  this.class = 'btn-primary rounded px-1 py-1';
                  window.scrollTo(document.documentElement.clientWidth, 0);
                  return 0;
              }else{
                  this.message = 'Upload Success';
                  this.class = 'btn-success rounded px-1 py-1';
                  window.scrollTo(document.documentElement.clientWidth, 0);
                  this.ngOnInit();
              } 
      },
      (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
          console.log("Client-side error occured.");
          } else {
          console.log("Server-side error occured.");
          }
      });
  }

  deleteRecord(event){
      if(confirm('Are You Sure?')){
        this.http.delete<any>(`${environment.apiUrl}/videos/${event.data._id}`, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
          data => {
            (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
            if(data.status == '500'){
              this.message = data.message;
              this.class = 'btn-primary rounded px-1 py-1';
              window.scrollTo(document.documentElement.clientWidth, 0);
              return 0;
            }else{
              this.message = 'Successfully Deleted';
              this.class = 'btn-success rounded px-1 py-1';
              window.scrollTo(document.documentElement.clientWidth, 0);
              this.ngOnInit();
            }
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        });
      }
    }

}
